import React from 'react';
import Banner from '../components/Banner';
import HeroSection from '../components/HeroSection';
import Features from '../components/Features';
import MainServices from '../components/MainServices';
import ContactCTA from '../components/ContactCTA';
import ReliableCareSection from '../components/ReliableCareSection';
import BestCareSection from '../components/BestCareSection';
import WhyChooseUs from '../components/WhyChooseUs';
import OtherServices from '../components/OtherServices';
import Gallery from '../components/Gallery';
import Testimonials from '../components/Testimonials';

const Home = () => {
  return (
    <div>
      <Banner />
      <HeroSection />
      <Features />
      <MainServices />
      <ContactCTA />
      <OtherServices />
      <ReliableCareSection />
      <BestCareSection />
      <WhyChooseUs />
      <Gallery />
      <Testimonials />
      <ContactCTA />
    </div>
  );
};

export default Home;
